module.exports = __webpack_public_path__ + "static/media/FaceKeyPoints@2x.cb8e96db.png";